import { createSlice } from "@reduxjs/toolkit";

interface LoadingState {
	isLoading: boolean;
	message: string;
}
const initialState: LoadingState = {
	isLoading: false,
	message: "Loading ...",
};

const loadingSlice = createSlice({
	name: "isLoading",
	initialState,
	reducers: {
		setLoading: (state, action) => {
			state.isLoading = action.payload.isLoading;
		},
	},
});

export const { setLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
